
theme = {
    init : function(){
        theme.stickyMenu();
        theme.modalLetter();
        theme.ajaxSearch();
        theme.account();
        theme.commonOwl();
        theme.isotopeTheme();
        theme.recentView();
        theme.featuredCollectionCarousel();
        theme.countDown();
        theme.singleProduct();
       // theme.close();
       theme.viewCompare();
       theme.removeCompareId();
       theme.productViewType();
       // theme.triggerMoney();
       // theme.scroll();
    },
    stickyMenu : function(){
        var h = $('#header').css('height');
        $('.sticky-menu').css('height',h);
        $(window).on('scroll',function(){
            if(window.innerWidth >= 992 ) {
                var y = window.pageYOffset;
                if(y >= 40){
                    $('.menu-stick').addClass('fixed-menu');
                }else{
                    $('.menu-stick').removeClass('fixed-menu');
                }
            }else{
                $('.menu-stick').removeClass('fixed-menu');
            }
        })
    },
    modalLetter : function(){
        function overlay(opacity,display,index){
            $('.popup-newsletter').each( function() {
                $(this).closest('.boxed').children('.overlay').css({
                    opacity: opacity,
                    display: display,
                    zIndex: index
                });
            });
        }
        if($('.popup-newsletter').length > 0){
            var state = getCookie('showModal');
            $('.popup-newsletter').hide();
            if(state == 'false'){
                overlay('1','block','89999');
                $('.popup-newsletter').show(400);
            }else{
                overlay('0','none','909');
            }
            $(".popup span" ).on('click', function() {
                $(this).closest('.popup-newsletter').hide(400);
                overlay('0','none','909');
            });
            $('#popup-not-show').change(function(){
                setCookie('showModal','not-show',60);
            });
        }
    },
    ajaxSearch : function(){
        var old_suggest = $('.suggested-result').html();
        $('#ajax-search').on('keyup',function(){
            var $this = $(this);
            setTimeout(function(){
                var key = $this.val();
                if(key.length == 0){
                    $('.suggested-result').html(old_suggest);
                    return;
                }
                var type = $('#ajax-search-type').val();
                var results = '';
                $.ajax({
                    type:'get',
                    url:'https://'+window.location.hostname+'/search?type='+type+'&q='+key+'&view=ajax',
                    async:false,
                    success : function (response){
                        results = response;
                    }
                })
                $('.suggested-result').html($(results).find('.ajax-results ul').html());
            },500)
        })
    },
    account : function(){
        $('.switch').on('click',function(e){
            e.preventDefault();
            var tab = $(this).attr('href');
            $('.tab-form').removeClass('active');
            $(tab).addClass('active');
        })
    },
    commonOwl : function(){
        $('.team-member').owlCarousel({
            autoplay:true,
            nav: false,
            dots: true,
            margin:30,
            loop:true,
            items:4,
            responsive:{
                0:{
                    items: 1,
                    dots: false,
                    nav: true,
                },
                479:{
                    items: 2,
                },
                599:{
                    items: 2,
                },
                768:{
                    items: 3
                },
                991:{
                    items: 4
                },
                1200: {
                    items: 4
                }
            }
        });
        $('.testimonial').owlCarousel({
            autoplay:true,
            nav: false,
            dots:true,
            margin:0,
            loop:true,
            items:1
        });
        $('.banner-list-collection').owlCarousel({
            autoplay:false,
            nav: false,
            dots:true,
            margin:0,
            loop:true,
            items:1
        });
        $('.recent-slide').owlCarousel({
            nav: true,
            dots: true,
            responsive: true,
            margin:30,
            loop:true,
            items:5,
            responsive:{
                0:{
                    items: 2,
                    dots: false,
                    margin:10,
                },
                479:{
                    items: 2,
                    dots: false
                },
                600:{
                    items: 3,
                    dots: false
                },
                768:{
                    items: 4,
                    margin:20,
                },
                991:{
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        });
        $('.box-cart>.inner-box>a').on('click',function(e){
            e.preventDefault();
            $('.list-item-cart').toggleClass('active');
        })
    },
    isotopeTheme : function(){
        $('.main-blog .tabs .menu-tab li').on('click',function(){
            var filter = $(this).data('filter');
            $(this).siblings('li').removeClass('active');
            $(this).addClass('active');
            $('.post-wrap.grid').isotope({filter:filter});
        });
        $('.brands-tablist li').on('click',function(){
            var filter = $(this).data('filter');
            $('.brands-list.grid').isotope({filter:filter});
        })
    },
    recentView : function(){

    },
    featuredCollectionCarousel : function(){
        $(".owl-carousel-1").owlCarousel({
            autoplay: true,
            nav: true,
            dots: false,
            margin:0,
            loop:true,
            items:1,
        });
    },
    countDown : function(){
       if($('.count-down').length > 0){
           $('.count-down').each(function(){
               var $this = $(this);
               var id = $this.data('id');
               var timeout = $this.data('timeout');
               var end = new Date(timeout);
               var _second = 1000;
               var _minute = _second * 60;
               var _hour = _minute * 60;
               var _day = _hour * 24;
               var timer = setInterval(function(){
                   var now = new Date();
                   var distance = end - now;
                   var div = $('.count-down-'+id);
                   if (distance > 0) {
                       var days = Math.floor(distance / _day);
                       var hours = Math.floor((distance % _day) / _hour);
                       var minutes = Math.floor((distance % _hour) / _minute);
                       var seconds = Math.floor((distance % _minute) / _second);
                       div.find('.day').html(days);
                       div.find('.hour').html(hours);
                       div.find('.minute').html(minutes);
                       div.find('.second').html(seconds);
                       return;
                   }
                   clearInterval(timer);
               }, 1000);
           })
       }
       $('.flexslider').flexslider({
           animation: "slide",
           controlNav: "thumbnails",
           after: function(e){
               activeSlide(e);
           }
       });
       $(document).on('click','.flex-control-nav li',function(){
           activeSlide($(this))
       })
       function activeSlide(e){
           var container = $(e).parents('.imagebox');
           var data = container.find('.flex-active-slide');
           container.find('.cat-name a').attr('href',$(data).data('cat-url')).html($(data).data('cat-title'));
           container.find('.product-name a').attr('href',$(data).data('url')).html($(data).data('title'));
           container.find('.price .sale').html($(data).data('price'));
           container.find('.price .regular').html($(data).data('compare-price'));
           container.find('.add-to-cart').attr('data-variant',$(data).data('variant'));
           container.find('.compare').attr('data-variant',$(data).data('id'));
           container.find('.add-wishlist').attr('data-variant',$(data).data('variant'));
       }
   },
    singleProduct : function(){
        if(typeof product_name != typeof undefined){
            theme.actionProduct(product_name,true);
        }
    },
    actionProduct : function(product_name,push){
        var single_product = $('.single-product-template');
        var data = '';
        $.ajax({
            type : "GET",
            url :'https://'+window.location.hostname+'/products/'+product_name+'.json',
            async : false,
            success : function(response){
                data = response.product;
            }
        });
        var variants = data.variants;
        var select = $('.select-variant');
        select.on('change',function () {
            theme.selectVariant(single_product, variants,push);
        });
    },
    selectVariant : function(single_product,variants,push){
        var option = [];
        var variant = [];
        var select = $('.select-variant');
        select.each(function () {
            option.push($(this).val());
        })
        option = option.join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
        for (var i in variants) {
            var vri = [variants[i].option1,variants[i].option2,variants[i].option3].join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
            if (vri === option) {
                variant = variants[i];
                theme.handleSelectVariant(single_product,variant,push);
                break;
            }
        }
    },
    handleSelectVariant : function(container,variant,state){
        if(variant) {
            var variant_id = $(container).find('[name="id"]');
            var price = $(container).find('.price');
            var wish = $(container).find('.add-wishlist');
            $(wish).attr('data-variant', variant.id);
            $(variant_id).val(variant.id);
            if(state == true){
                window.history.pushState({}, '', '?variant=' + variant.id);
            }
            if (parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
                $(price).find('.sale').html('<span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.price)+'">'+money_format + (variant.price)+'</span>');
                $(price).find('.regular').html('<span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.compare_at_price)+'">'+money_format + (variant.compare_at_price)+'</span>' ).show();
            } else {
                $(price).find('.sale').html('<span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.price)+'">'+money_format + (variant.price)+'</span>');
                $(price).find('.regular').hide();
            }
            if (variant.image_id != null) {
                var id = variant.image_id;
                $(container).find('[data-id="'+id+'"]').trigger('click');
            }
            theme.wishlist(container, variant.id);
        }
    },
    wishlist : function(main,variant_id){
        if(typeof customer_id != typeof undefined){
            var wished = true;
            if(wishlists.indexOf(variant_id.toString()) < 0){
                wished = false;
            }
            if(wished){
                $(main).find('.add-wishlist i').removeClass('fa-heart-o').addClass('fa-heart');
            }else{
                $(main).find('.add-wishlist i').addClass('fa-heart-o').removeClass('fa-heart');
            }
        }
    },
    close : function(){
       $('.close-aside').on('click',function(){
           $('.aside-shop').removeClass('active');
       })
   },
    getHtmlCompare : function(name){
        var html_compare = '';
        var url = 'https://' + window.location.hostname + '/products/'+name+'?view=data-compare';
        $.ajax({
            url: url,
            type: 'get',
            async: false,
            success: function (html) {
                html_compare = html;
            },
        });
        return $(html_compare).find('#compare-' + name).html();
    },
    viewCompare : function(){
        $(document).on('click','.compare',function(e){
            e.preventDefault();
            var name = $(this).data('name');
            theme.actionCompareId('add',name);
            window.location = 'https://' + window.location.hostname + '/pages/compare';
        });
        if($('.compare-content').length > 0){
            theme.showModalCompare();
        }
    },
    getCompareData : function(){
        var arrs = getCookie('_compare_list');
        var html = '';
        if(arrs != false){
            arrs = arrs.split(',');
            $.each(arrs,function(i,e){
                if(e.length > 0 && e != 'undefined'){
                    var data_html = theme.getHtmlCompare(e);
                    if(data_html != undefined){
                        html += data_html;
                    }
                }
            });
            return html;
        }
        return html;
    },
    actionCompareId : function(action,id){
        var arrs = getCookie('_compare_list');
        if(action == 'add'){
            if(arrs != false) {
                arrs = arrs.split(',');
                if (jQuery.inArray(id, arrs) < 0) {
                    arrs.push(id);
                    setCookie('_compare_list', arrs, 60);
                }
            }else{
                setCookie('_compare_list',id,60);
            }
        }else{
            arrs = arrs.split(',');
            var index = arrs.indexOf(id);
            console.log(index);
            if (index > -1) {
                arrs.splice(index, 1);
                setCookie('_compare_list',arrs,60);
            }
        }
    },
    showModalCompare : function(){
        var html = theme.getCompareData();
        var owl_compare = $('.compare-content');
        if(html.length < 5){
            $('.compare-content').html('<p class="text-center">No product in your compare list!</p>');
            return;
        }
        owl_compare.html(html);
        owl_compare.trigger('destroy.owl.carousel');
        setTimeout(function(){
            owl_compare.addClass('owl-carousel').owlCarousel({
                nav:false,
                responsiveClass: true,
                dots:true,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    }
                }
            });
        },300);
    },
    removeCompareId : function(){
       $(document).on('click','.remove-from-compare',function(e){
           e.preventDefault();
           var name = $(this).data('name').toString();
           theme.actionCompareId('remove',name);
           theme.showModalCompare();
       });
   },
    quickChangeColor : function(){
       $(document).on('click','.variant-color',function(e){
           e.preventDefault();
           var image = $(this).data('image');
           var variant_id = $(this).data('variant-id');
           var price = $(this).data('price');
           var compare_price = $(this).data('compare-price');

           var parent = $(this).parents('.product-inner');

           parent.find('.lazy').attr('src',image);
           parent.find('.add_to_wishlist').attr('data-variant-id',variant_id);
           parent.find('.add_to_cart_button').attr('data-variant-id',variant_id);
           parent.find('.price>span').html(compare_price+price);
           $('body').trigger('convert.money');
           theme.changeMoney();
           theme.wishlist(parent,variant_id);
       })
   },
    triggerMoney : function(){
       setTimeout(function(){
           var cur = $('.current-money').find('span').data('currency');
           $('.'+cur).addClass('active').siblings('li').removeClass('active');
           $('.currency a').html(cur);
       },1000);
       $(document).on('click','.filter-type',function () {
           theme.changeMoney();
       });
       $(document).on('click','.switcher-price',function(){
           var currency = $(this).find('a').data('currency');
           $(this).siblings('li').removeClass('active');
           $(this).addClass('active');
           $('.currency-picker').val(currency).trigger('change');
       })
   },
    changeMoney : function(){
       var current = $('.currency-picker').val();
       $('.currency-picker').val('USD').trigger('change');
       $('.currency-picker').val(current).trigger('change');
   },
    removeCartItem : function(){
       $('.remove-item').on('click',function(e){
           var del = confirm('Are you sure, you want to delete this item ?');
           if(!del){
               e.preventDefault();
               return;
           }
       })
   },
    productViewType : function(){
        if($('.shop-result-list').length > 0) {
            var type = getCookie('_view_type');
            $('.product-view-type').removeClass('active');
            if (type == 'grid-view') {
                $('.sort-box.shop-result-list').removeClass('list-view').addClass('grid-view');
                $('li[data-type="grid-view"]').addClass('active');
            } else {
                $('.sort-box.shop-result-list').removeClass('grid-view').addClass('list-view');
                $('li[data-type="list-view"]').addClass('active');
            }

            $('.product-view-type').on('click', function (e) {
                e.preventDefault();
                var type = $(this).data('type');
                $(this).siblings('.product-view-type').removeClass('active');
                $(this).addClass('active');
                if (type == 'list-view') {
                    $('.sort-box.shop-result-list').addClass(type).removeClass('grid-view');
                } else {
                    $('.sort-box.shop-result-list').addClass(type).removeClass('list-view');
                }
                setCookie('_view_type', type, 60);
            })
        }
   },
    scroll : function(){
       if($('.style9').length > 0) {
           var h = $('.header-container').height();
           $('#header').css('height', h + 'px');
           $(window).on('scroll', function () {
               h = $('.header-container').height();
               $('#header').css('height', h + 'px');
               if (window.pageYOffset > 0) {
                   $('.header-container').addClass('fixed');
               } else {
                   $('.header-container').removeClass('fixed');
               }
           })
       }
   }
}

theme.init();
var social = {
    datas : {"links":[],"images":[]},
    getInsImage : function(number){
        $.ajax({
            method: 'GET',
            url : 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + access_token + '&count='+number+'&callback=?',
            error: function(response){
                console.log(response.message);
            },
            success: function (response) {
                if(response.meta.code == 200){
                    $.each(response.data,function(i,e){
                        social.datas.links.push(e.link);
                        social.datas.images.push(e.images.standard_resolution.url);
                    });
                }
            },
            dataType: 'jsonp'
        });
    }
}
SlideShow = {
    init:function(){
        $('.slide-show').each(function(){
            var id = $(this).data('id');
            SlideShow.build(id);
        })
    },
    build:function(id){
        var slide_show = $('#slide-show-'+id);
        var options = slide_show.data('options');
        slide_show.owlCarousel({
            nav:slide_show.hasClass('owl-carousel-15')?true:false,
            dots:true,
            autoplay:options.autoplay,
            autoplayTimaout:options.autoplayTimeout,
            loop:options.loop,
            //navText:['<i class="fa fa-long-arrow-left"></i>','<i class="fa fa-long-arrow-right"></i>'],
            items:1
        })
        $(".box-image-1").owlCarousel({
            autoplay: true,
            nav: true,
            dots: false,
            margin:0,
            loop:true,
            items:1,
        });
    }
}
SlideShow.init();
AllProduct = {
    init : function(){
        $('.all-product').each(function(){
            var id = $(this).data('id');
            AllProduct.build(id);
        })
    },
    build : function(id){
        var slide = $('#all-product-'+id);
        var options = slide.data('options');
        slide.owlCarousel({
            autoplay:options.autoplay,
            nav: false,
            dots: true,
            margin:30,
            loop:true,
            items:options.items,
            responsive:{
                0:{
                    items: 1,
                    dots: false
                },
                479:{
                    items: 1,
                    dots: false
                },
                599:{
                    items: 1,
                    dots: false
                },
                768:{
                    items: 2,
                    dots: false
                },
                991:{
                    items: 3
                },
                1200: {
                    items: options.items
                }
            }
        });
    }
}
AllProduct.init();
SaleProduct = {
    init : function(){
        $('.sale-slide').each(function(){
            var id = $(this).data('id');
            SaleProduct.build(id);
        })
    },
    build : function(id){
        var slide = $('#sale-slide-'+id);
        var options = slide.data('options');
        slide.owlCarousel({
            autoplay:options.autoplay,
            nav: true,
            dots: false,
            margin:20,
            loop:true,
            items:1
        });
    }
}
SaleProduct.init();
MostView = {
    init : function(){
        $('.most-view').each(function(){
            var id = $(this).data('id');
            MostView.build(id);
        })
    },
    build : function(id){
        var slide = $('#most-view-'+id);
        slide.owlCarousel({
            autoplay:true,
            nav: true,
            dots: true,
            margin:30,
            loop:true,
            items:5,
            responsive:{
                0:{
                    items: 2,
                    dots: false,
                    margin:10,
                },
                479:{
                    items: 2,
                    dots: false
                },
                600:{
                    items: 3,
                    dots: false
                },
                768:{
                    items: 4,
                    margin:20,
                },
                991:{
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        });
    }
}
MostView.init();
BestSeller = {
    init : function(){
        BestSeller.build();
    },
    build : function(){
        var slide = $('.best-seller');
        slide.owlCarousel({
            nav: true,
            dots: false,
            responsive: true,
            margin:20,
            loop:true,
            items:1
        })
    }
}
BestSeller.init();
BrandSlide = {
    init : function(){
        $('.brand-slide').each(function(){
            var id = $(this).data('id');
            BrandSlide.build(id);
        })
    },
    build : function(id){
        var options = $(".brand-slide-"+id).data('options');
        $(".brand-slide-"+id).owlCarousel({
            autoplay:true,
            nav: false,
            dots: options.dots,
            margin:20,
            loop:true,
            items:5,
            responsive:{
                0:{
                    items: 2
                },

                479:{
                    items: 4
                },
                768:{
                    items: 4
                },
                991:{
                    items: 5
                },
                1200: {
                    items: 5
                }
            }
        });
    }
}
BrandSlide.init();
$(document).on('shopify:section:load', function (e) {
    var data = e.target.attributes;
    var array;
    for(var i in data){
        if(data[i].nodeValue.indexOf("}") > 0){
            array = data[i].nodeValue;
            break;
        }
    }
    var section = JSON.parse(array);
    theme.init();
    switch (section.type){
        case 'slide-show':
            SlideShow.build(section.id);
            break;
        case 'all-product':
            AllProduct.build(section.id);
            break;
        case 'sale-slide':
            SaleProduct.build(section.id);
            break;
        case 'most-view':
            MostView.build(section.id);
            break;
        case 'best-seller':
            BestSeller.build();
            break;
        case 'brand-slide':
            BrandSlide.build(section.id);
            break;
    }
})
